<script>
  import MenuItem from "./MenuItem.svelte";
  import {BeginnerMenu} from "@util/constant.js"
</script>


<MenuItem Menu={BeginnerMenu} />
